import Model from "@/components/common/model.component";
import React, { useState } from "react";
import Image from "next/image";
import AddIcon from "assets/svg/add.svg";
import Form from "@/components/common/form/form";
import { authServices } from "services/auth.services";
import { useSwrGet } from "@/utils/use-swr-get";
import { setValveData } from "@/redux/actions/valves/valveData";
import { useDispatch, useSelector } from "react-redux";
import { PumpService } from "services/assets-pump.services";
import LocationModal from "./locationModal";
import { useTranslation } from "react-i18next";
import PumpForm from "./pumpForm";
import PageTitle from "components/common/page-title.component";

function Pump({ setRefresh, type, showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [showLocationModal, setLocationModal] = useState(false);
  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );
  const [icon, setIcon] = useState("PMP-");
  const onSubmit = async (data) => {
    data.item_code = "PMP-" + data.item_code;
    data.farm_id = Number(data.farm_id);
    data.object_id = Number(data.object_id);
    data.entity_type_id = 9;
    data.attributes_value.efficiency = Number(data.attributes_value.efficiency);
    data.attributes_value.flow_rate_m3_per_h = Number(
      data.attributes_value.flow_rate_m3_per_h
    );
    data.org_id = authServices.userValue.org_id;
    data.content_type = farmData
      ?.filter?.((item) => item.farm_id == data.farm_id)
      ?.map?.((item) =>
        item.farm_type === "tree"
          ? authServices.userValue.content_types
              ?.filter?.((item) => item.model == "treefieldinfo")
              ?.find?.((item) => item.id)?.id
          : authServices.userValue.content_types
              ?.filter?.((item) => item.model == "pivotfieldinfo")
              ?.find?.((item) => item.id)?.id
      )[0];
    let res = await PumpService.addPump(data);
    if (res) {
      dispatch(
        setValveData({
          id: res.data.id,
          entity_type_id: res.data.entity_type_id,
        })
      );
      setLocationModal(true);
    }
  };
  return (
    <>
      <Model
        width="w-130"
        show={showModal}
        onClose={(e) => {
          setShowModal(false);
        }}
      >
        <PageTitle title={t("AddPump")} titletextSize="text-xl" />

        <Form onSubmit={onSubmit}>
          <PumpForm type={type} passProps icon={icon} />
        </Form>
      </Model>
      <LocationModal
        setRefresh={setRefresh}
        showModal={showLocationModal}
        setShowModal={setLocationModal}
        closeMainModal={setShowModal}
      />
    </>
  );
}

export default Pump;
